import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type CorrectnessBreakdownResponse = {
  total: Total
  audited: Audited
  correctness: Correctness
  correctnessBreakdown: CorrectnessBreakdown[]
  exceedsMinResolutions: {
    total: {
      current: number
      previous: number
    }
    percentage: {
      current: number
      previous: number
    }
    trend: number
  }
  program: { targetAccuracy: number }
}

type DefaultStats = {
  current: number
  previous: number
  trend: number
}

type Total = DefaultStats
type Audited = DefaultStats
type Correctness = DefaultStats

type CorrectnessBreakdown = {
  timeslice: string
  correct_count: number
  incorrect_count: number
  avg_accuracy: number
  correct_percentage: number
}
export const PROGRAM_MS_CORRECTNESS_BREAKDOWN_STATS_KEY = 'program-ms-correctness-breakdown-stats'

export function useGetCorrectnessBreakdown(
  period: { start: string; end: string } | null,
  programId?: string,
  granularity?: 'daily' | 'monthly' | 'weekly',
  scope?: 'live'
) {
  return useQuery<CorrectnessBreakdownResponse>({
    queryKey: [
      PROGRAM_MS_CORRECTNESS_BREAKDOWN_STATS_KEY,
      programId,
      period?.start,
      period?.end,
      granularity,
      scope,
    ],
    queryFn: async () => {
      const { data } = await apiClient.get(`int/stats/program/correctness-breakdown`, {
        params: {
          program_id: programId,
          start_time: period?.start,
          end_time: period?.end,
          granularity: granularity,
          ...(scope ? { scope } : {}),
        },
      })
      return data
    },
    enabled: Boolean(programId) && Boolean(period) && Boolean(granularity),
  })
}
